import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Database } from '../../../definitions/database';
import { DatabasesService } from '../services/databases.service';

/**
 * Resolver function for loading databases associated with a specific application.
 *
 * This resolver:
 * - Extracts the application ID from the route parameters
 * - Validates the application ID format
 * - Fetches databases from the ApplicationsService
 * - Dispatches appropriate store actions for success/failure states
 * - Handles errors with user-friendly translated messages
 * - Redirects to error page for critical failures
 *
 * @param route - The activated route snapshot containing route parameters
 * @returns Observable of Database array, or navigation to error page on failure
 *
 * @throws {Error} When appId parameter is missing or invalid
 * @throws {Error} When database service call fails
 *
 * @example
 * // Route configuration
 * {
 *   path: 'app/:appId/databases',
 *   resolve: { databases: databasesResolverFn },
 *   component: DatabaseListComponent
 * }
 */
export const datasourcesLoaderResolverFn: ResolveFn<Array<Database>> = (
	route: ActivatedRouteSnapshot
): Observable<any> => {
	const databasesSvc = inject(DatabasesService);
	return of(databasesSvc.loadDatabases());
};
